'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(theme) {
  return {
    container: {
      marginBottom: theme.spacing.unit * 2
    },
    button: {
      textTransform: 'capitalize',
      background: 'transparent',
      border: '1px solid ' + theme.palette.primary.main,
      borderRadius: 4,
      color: theme.palette.primary.main,
      width: '100%'
    },

    selectedButton: {
      textTransform: 'capitalize',
      borderRadius: 4,
      background: theme.palette.primary.main,
      color: 'white',
      border: '1px solid ' + theme.palette.primary.main,
      width: '100%',
      '&:hover': {
        background: theme.palette.primary.main
      }
    }
  };
};

function ButtonSelectable(_ref) {
  var options = _ref.options,
      input = _ref.input,
      _ref$meta = _ref.meta,
      touched = _ref$meta.touched,
      error = _ref$meta.error,
      classes = _ref.classes,
      disabled = _ref.disabled;

  var paymentInfo = {
    BANK_OFFLINE: {
      desc: _react2.default.createElement(
        'span',
        null,
        'Please contact your bank to initiate your wire. ',
        _react2.default.createElement('br', null),
        ' This is an off-platform form of payment. ',
        _react2.default.createElement('br', null),
        ' Wiring instructions will be found on the Payment Details tab.'
      )
    },
    BANK_WIRE: {
      desc: _react2.default.createElement(
        'span',
        null,
        'The ACH will be processed using Stripe. ',
        _react2.default.createElement('br', null),
        ' Please note there is an ACH maximum of $999,999.99.'
      )
    },
    BANK_ACH: {
      desc: _react2.default.createElement(
        'span',
        null,
        'Credit Card payments are processed using Stripe. ',
        _react2.default.createElement('br', null),
        ' Please note there is a credit card payment maximum of $6,000.'
      )
    }
  };

  return _react2.default.createElement(
    _materialUi.Grid,
    { className: classes.container, container: true, spacing: 24 },
    options.map(function (item, index) {
      return _react2.default.createElement(
        _materialUi.Grid,
        {
          key: 'selectable ' + (index + 1),
          item: true,
          xs: 12,
          sm: 12 / options.length
        },
        _react2.default.createElement(
          _materialUi.Button,
          {
            disableRipple: true,
            disableFocusRipple: true,
            disabled: disabled,
            variant: 'outlined',
            'data-tip': true,
            'data-for': item.value,
            className: input.value === item.value ? classes.selectedButton : classes.button,
            onClick: function onClick() {
              return input.onChange(item.value);
            },
            size: 'small'
          },
          item.label
        ),
        item.value === 'BANK_OFFLINE' || item.value === 'BANK_WIRE' || item.value === 'BANK_ACH' ? _react2.default.createElement(
          _reactTooltip2.default,
          {
            id: item.value,
            multiline: true,
            place: 'top',
            type: 'info',
            effect: 'solid'
          },
          paymentInfo && paymentInfo[item.value].desc || ''
        ) : ''
      );
    }),
    touched && error ? _react2.default.createElement(
      _materialUi.Grid,
      { item: true, xs: 12 },
      _react2.default.createElement(
        'span',
        { style: { color: '#ff1744' } },
        error
      )
    ) : null
  );
}

ButtonSelectable.propTypes = {
  options: _propTypes2.default.array.isRequired,
  input: _propTypes2.default.object.isRequired,
  meta: _propTypes2.default.object.isRequired,
  classes: _propTypes2.default.object.isRequired,
  disabled: _propTypes2.default.bool
};

ButtonSelectable.defaultProps = {
  disabled: false
};

exports.default = (0, _materialUi.withStyles)(styles)(ButtonSelectable);